let defaultGestionForm = {
    id: '',
    name: '',
    operator: null,
    tipoGestion: null,
}

export default defaultGestionForm